import ConfirmTransition from '../../../../components/confirm-transition'
import { AquiferTestSummaryTable } from '../../../../components/well-forms/aquifer-test/summary-table'
import { useEffect, useState } from 'react'
import { useWellState } from '../../../../context/well-context'
import WellEditButtons from '../../../../components/wells/well-edit-buttons'
import { useSaveWellData } from '../../../../hooks/use-api'
import { HandleSave } from '../../../../hooks/use-edit-form'
import useToastMessage from '../../../../hooks/use-toast-message'
import { HttpVerb } from '../../../../../types/api-types'
import { useWellId } from '../../../../hooks/use-well-id'
import { useNavigate } from 'react-router-dom'
import { Heading, RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'

export function EditWellAquiferTests() {
  const {
    wellState: { isDraft, hasNoAquiferTestRecords, isLegacyWell },
  } = useWellState()
  useTitleChange(`${isDraft ? 'New' : 'Edit'} Well | Aquifer tests summary`)
  const navigate = useNavigate()
  // Form fields
  const [fields, setFields] = useState<Array<Record<string, string | number | boolean>> | null>(null)
  const wellId = useWellId()
  const [isNoTestsChecked, setIsNoTestChecked] = useState(hasNoAquiferTestRecords)
  const continueUrl = `/wells/${wellId}/edit/additional-documents`

  const { mutate, isError, isSuccess, error } = useSaveWellData(`wells/${wellId}/aquifer-test/`, HttpVerb.PATCH)

  const handleNoTestsCheckbox = (checked: boolean) => {
    setIsNoTestChecked(checked)
  }

  useEffect(() => {
    setIsNoTestChecked(hasNoAquiferTestRecords || isLegacyWell)
  }, [hasNoAquiferTestRecords, isLegacyWell])

  const handleSave: HandleSave = (callback?) => {
    mutate &&
      mutate(JSON.stringify({ hasNoAquiferTestRecords: isNoTestsChecked }), {
        onSuccess: (data) => {
          callback && callback(data.id)
        },
      })
  }

  useToastMessage({ error, isError, isSuccess })

  return (
    <>
      <RecordContent>
        <Heading level={2}>Aquifer tests</Heading>
        <AquiferTestSummaryTable
          fields={fields}
          setFields={setFields}
          handleNoTestsCheckbox={handleNoTestsCheckbox}
          isNoTestsChecked={isNoTestsChecked}
        />
      </RecordContent>
      <RecordFooter>
        {
          <WellEditButtons
            actions={
              !fields?.length
                ? [
                    {
                      label: 'Save and continue',
                      buttonStyle: 'primary',
                      onClick: () =>
                        handleSave(() => {
                          navigate(continueUrl)
                        }),
                    },
                    {
                      label: 'Save',
                      buttonStyle: 'primary',
                      onClick: () => handleSave(),
                    },
                    {
                      label: 'Cancel',
                      buttonStyle: 'text-action',
                      onClick: () => navigate(`/dashboard`),
                    },
                  ]
                : [
                    {
                      label: 'Continue',
                      buttonStyle: 'primary',
                      onClick: () => {
                        navigate(continueUrl)
                      },
                    },
                    {
                      label: 'Cancel',
                      buttonStyle: 'secondary',
                      onClick: () => navigate(`/dashboard`),
                    },
                  ]
            }
          />
        }
      </RecordFooter>
    </>
  )
}

export default function EditWellAquiferTestsWrapped() {
  return (
    <ConfirmTransition isFormDirty={false}>
      <EditWellAquiferTests />
    </ConfirmTransition>
  )
}
